module.exports = __webpack_public_path__ + "bc3547e51c1385f32c50bed04ab60be4.pdf";